const SVG_PLACEHOLDER_PATTERN = /{{\s*[^{}]+\s*}}/;

function parseSvg(svgText) {
  if (!svgText || typeof svgText !== "string") {
    return null;
  }

  try {
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svgText, "image/svg+xml");
    if (svgDoc.querySelector("parsererror")) {
      return null;
    }
    return svgDoc;
  } catch {
    return null;
  }
}

export function getTspanTextValues(svgText) {
  const svgDoc = parseSvg(svgText);
  if (!svgDoc) {
    return null;
  }

  return Array.from(svgDoc.querySelectorAll("text, tspan"))
    .filter((element) => {
      const tagName = element.tagName?.toLowerCase();
      return tagName !== "text" || element.querySelectorAll("tspan").length === 0;
    })
    .map((element) => element.textContent || "");
}

export function hasTspanPlaceholder(svgText) {
  const tspanTextValues = getTspanTextValues(svgText);
  if (!tspanTextValues) {
    return false;
  }

  return tspanTextValues.some((textValue) =>
    SVG_PLACEHOLDER_PATTERN.test(textValue),
  );
}

export function validateCertificateSvgText(svgText, slotKey) {
  const tspanTextValues = getTspanTextValues(svgText);
  if (!tspanTextValues || tspanTextValues.length === 0) {
    return "invalid_svg_file";
  }

  const containsRenderedPlaceholder = tspanTextValues.some((textValue) =>
    SVG_PLACEHOLDER_PATTERN.test(textValue),
  );

  if (slotKey === "previewSvg" && containsRenderedPlaceholder) {
    return "invalid_preview_svg";
  }

  if (slotKey === "templateSvg" && !containsRenderedPlaceholder) {
    return "invalid_template_svg";
  }

  return null;
}

export function readFileAsText(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(reader.error);
    reader.readAsText(file);
  });
}

export async function validateCertificateSvgFile(file, slotKey) {
  const svgText = await readFileAsText(file);
  return validateCertificateSvgText(svgText, slotKey);
}
